import React from 'react';
import {
  Box,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  Stack,
} from '@chakra-ui/react';

const DashboardSkeleton: React.FC = () => {
  return (
    <Stack spacing={6}>
      <Box
        bg="white"
        borderWidth="1px"
        borderColor="gray.200"
        borderRadius={{ base: '20px', md: '24px' }}
        p={{ base: 5, md: 7 }}
      >
        <Skeleton height="18px" width="140px" mb={4} />
        <Skeleton height="34px" width={{ base: '70%', md: '42%' }} mb={3} />
        <SkeletonText noOfLines={2} spacing="3" maxW="560px" />
      </Box>

      <SimpleGrid columns={{ base: 1, sm: 2, xl: 4 }} spacing={4}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box
            key={index}
            bg="white"
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius="20px"
            p={5}
          >
            <Skeleton height="14px" width="120px" mb={4} />
            <Skeleton height="28px" width="90px" mb={2} />
            <Skeleton height="12px" width="140px" />
          </Box>
        ))}
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={4}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Box
            key={index}
            bg="white"
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius="20px"
            p={5}
          >
            <Skeleton height="16px" width="180px" mb={5} />
            <Skeleton height="260px" borderRadius="16px" />
          </Box>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default DashboardSkeleton;
